import React, { useEffect, useRef } from "react";

const DisplayCard = ({
  videoUrl,
  scrollingText,
  textSettings,
  status, // "Online" or "Offline"
  name,
  campusName,
  location,
  displayGroupName,
  displayGroupId,
}) => {
  const parseRichText = (text) => {
    // Replace *text* with <b>text</b>
    let formattedText = text.replace(/\*(.*?)\*/g, '<b>$1</b>');
  
    // Replace _text_ with <u>text</u>
    formattedText = formattedText.replace(/\_(.*?)\_/g, '<u>$1</u>');
  
    return formattedText;
  };
  const marqueeRef = useRef();

  // Map displayGroupId to a color (use consistent colors for identical IDs)
  const getColorFromId = (id) => {
    const colors = [
        "#FFC107", // Amber
        "#03A9F4", // Light Blue
        "#4CAF50", // Green
        "#E91E63", // Pink
        "#9C27B0", // Purple
        "#FF5722", // Deep Orange
        "#009688", // Teal
        "#3F51B5", // Indigo
        "#FF9800", // Orange
        "#2196F3", // Blue
        "#8BC34A", // Light Green
        "#FFEB3B", // Yellow
        "#673AB7", // Deep Purple
        "#795548", // Brown
        "#607D8B", // Blue Grey
        "#00BCD4", // Cyan
        "#9E9E9E", // Grey
        "#CDDC39", // Lime
        "#FF4081", // Pink Accent
        "#00BFAE", // Light Teal
      ];
      
    return colors[id % colors.length]; // Cycle through predefined colors
  };

  useEffect(() => {
    if (marqueeRef.current && scrollingText) {
      const formattedText = parseRichText(scrollingText);
      // Duplicate the text to ensure smooth scrolling
      marqueeRef.current.innerHTML = formattedText + " " + formattedText 


      // Animate the scrolling text
      const keyframes = [
        { transform: "translateX(0%)" },
        { transform: "translateX(-200%)" },
      ];

      marqueeRef.current.animate(keyframes, {
        duration: 10000 / (textSettings.scroll_speed || 1), // Adjust speed as needed
        iterations: Infinity,
      });
    }
  }, [scrollingText, textSettings]);
  
  const displayGroupColor = getColorFromId(displayGroupId);
  const bannerHeight = parseInt(textSettings.font_size) * 1.5;
  // Styles for marquee and banner
  const marqueeStyle = {
    fontSize: textSettings.font_size,
    color: textSettings.font_color,
    // animation: `scrollingTextAnimation ${textSettings.scroll_speed || 1}s linear infinite`,
    top: textSettings.text_position === 0 ? "0" : "auto",  // Top position if text_position is 0
    bottom: textSettings.text_position === 1 ? "0" : "auto", // Bottom position if text_position is 1
    opacity: 1
  };
  const bannerStyle = {
    backgroundColor: textSettings.banner_color,
    opacity: textSettings.banner_opacity,
    height: `${bannerHeight}px`, // Apply dynamic height based on font size
    top: textSettings.text_position === 0 ? "0" : "auto",  // Top position if text_position is 0
    bottom: textSettings.text_position === 1 ? "0" : "auto", // Bottom position if text_position is 1
  };
  
  return (
    <div className="display-card">
      <div className="video-container">
        {videoUrl ? (
          <video
            src={videoUrl}
            autoPlay
            muted
            loop
            className="video-element"
          />
        ) : (
          <div className="no-video">No video added</div>
        )}
        {scrollingText && (<>
          <div className="scrolling-text-bg" style={bannerStyle}>          
        </div>
        <div ref={marqueeRef} className="scrolling-text" style={marqueeStyle}>
        {scrollingText}
      </div>
      </>
        )}
      </div>
      <div className='display-card-status-group-container'>
      <div className={status === 1 ? "displaycard as-green-bg-smooth" : "displaycard as-red-bg-smooth"}>
        <i className="fas fa-circle mr-1"></i>{status === 1 ? "ONLINE" : "OFFLINE"}
      </div>
      <div
        className="display-group-name"
        style={{ backgroundColor: displayGroupColor }}
      >
        {displayGroupName}
      </div>
      </div>
      <div className="display-name">{name}</div>
      <div className="display-card-campus">
        <i className="fa fa-university mr-1"></i>{campusName}, {location}
      </div>  
    </div>
  );
};

export default DisplayCard;
